<template>
    <div class="disease-research">
        <section
            v-for="item in sections"
            :id="item.id"
            :key="item.key"
            class="research-section"
        >
            <div class="section-head">
                <h3 class="section-tit">{{ item.title }}</h3>
            </div>
            <div class="section-body">
                <research-literature v-if="item.key === 'literature'" />
                <clinical-trial v-else-if="item.key === 'clinical'" />
                <basic-experiment v-else-if="item.key === 'basic'" />
                <case-report v-else-if="item.key === 'case'" />
                <guideline-consensus v-else-if="item.key === 'guideline'" />
                <doctor-experience v-else-if="item.key === 'experience'" />
                <review-commentary v-else-if="item.key === 'review'" />
            </div>
        </section>
    </div>
</template>

<script>
import ResearchLiterature from './comps/research_literature.vue';
import ClinicalTrial from './comps/clinical_trial.vue';
import BasicExperiment from './comps/basic_experiment.vue';
import CaseReport from './comps/case_report.vue';
import GuidelineConsensus from './comps/guideline_consensus.vue';
import DoctorExperience from './comps/doctor_experience.vue';
import ReviewCommentary from './comps/review_commentary.vue';

export default {
    name: 'DiseaseResearch',
    components: {
        ResearchLiterature,
        ClinicalTrial,
        BasicExperiment,
        CaseReport,
        GuidelineConsensus,
        DoctorExperience,
        ReviewCommentary,
    },
    data() {
        return {
            sections: [
                { key: 'literature', id: 'researchLiterature', title: '科研文献' },
                // { key: 'clinical', id: 'clinicalTrial', title: '临床试验' },
                // { key: 'basic', id: 'basicExperiment', title: '基础实验' },
                // { key: 'case', id: 'caseReport', title: '个案报道' },
                // { key: 'guideline', id: 'guidelineConsensus', title: '指南与共识' },
                // { key: 'experience', id: 'doctorExperience', title: '名医经验' },
                // { key: 'review', id: 'reviewCommentary', title: '述评与综述' },
            ],
        };
    },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
